/* ---- Event card (for history list) ---- */

import { ICONS } from '../icons';
import type { EventItem } from '../types';
import { escapeHtml } from '../utils/html';

function typeBadgeClass(type: string): string {
  switch (type) {
    case 'zone_entry':
      return 'be';
    case 'zone_stay':
      return 'bs';
    case 'zone_exit':
      return 'bx';
    default:
      return 'be';
  }
}

function typeLabel(type: string): string {
  switch (type) {
    case 'zone_entry':
      return '入場';
    case 'zone_stay':
      return '滞在';
    case 'zone_exit':
      return '退場';
    default:
      return type;
  }
}

function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${day} ${h}:${min}`;
}

export function renderEventCard(event: EventItem, onClick: () => void): HTMLElement {
  const el = document.createElement('div');
  el.className = 'ec';

  const isStay = event.type === 'zone_stay';
  const vcIssued = event.vc_status === 'issued';

  let dateHtml: string;
  if (isStay && event.date_from && event.date_to) {
    dateHtml = `
      <div class="ft">
        <div class="ln"><span class="lb">FROM</span><span>${formatDate(event.date_from)}</span></div>
        <div class="ln"><span class="lb">TO</span><span>${formatDate(event.date_to)}</span></div>
      </div>
    `;
  } else {
    dateHtml = `<div class="ds">${formatDate(event.date)}</div>`;
  }

  el.innerHTML = `
    <div class="et">
      <div class="ef">${escapeHtml(event.fence)}</div>
      <span class="bg ${typeBadgeClass(event.type)}">${typeLabel(event.type)}</span>
    </div>
    ${dateHtml}
    <div class="eb">
      ${vcIssued ? ICONS.check : ICONS.cross}
      <span class="vl ${vcIssued ? 'vo' : 'vn'}">${vcIssued ? 'VC発行' : 'VC未発行'}</span>
      ${ICONS.chevron}
    </div>
  `;

  el.addEventListener('click', onClick);
  return el;
}
